export default __webpack_public_path__ + "static/expo2-714ddbfa02a7815cc65cf552af32cc60.jpg";